<template>
  <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2 wf-px-1' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div :class="elementClasses(classes('classes'), classes('customClasses'))">
      <WysiwygEditor
        v-show="! previewMode"
        :containerClasses="['hover:wf-bg-white', 'wf-border', 'wf-rounded', 'wf-p-4']"
        allowNewRow
        :value="content.text"
        @input="updateContentProperty('text', $event)"
      />
      <div v-show="previewMode" v-html="content.text"></div>
    </div>
  </div>
</template>

<script>
  import WysiwygEditor from './WysiwygEditor'
  import EditorComponent from '../contracts/EditorComponent'
  export default EditorComponent.extend({
    components: {WysiwygEditor},
  })
</script>